import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconBeachGravel = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconBeachGravel",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M12 19c-4.58 0-7-.8-7-2.33s2.42-2.34 7-2.34q6.99 0 7 2.34-.01 2.32-7 2.33m.3-5.25c-4.59 0-5.55-1.27-5.55-2.33 0-1.07.96-2.34 5.54-2.34 3.47 0 5.54.88 5.54 2.34s-2.07 2.33-5.54 2.33M10.82 8.5c-2.12 0-3.5-.69-3.5-1.75S8.71 5 10.83 5s3.5.69 3.5 1.75-1.37 1.75-3.5 1.75"
  })
}));
IconBeachGravel.displayName = 'IconBeachGravel';